/* eslint-disable jsx-control-statements/jsx-jcs-no-undef */
export const isInfraDemoPage = typeof window === 'object' ? window.location.pathname.indexOf('/web3-infra') > -1 : false;

export const molyLightThemeClass = 'moly-theme-component-light';
export const molyDarkThemeClass = 'moly-theme-component-dark';

export const innerUseNativeTokenDecimal = 18;

export const infraVersion = __SDK_VERSION__;
export const commitHash = __COMMIT_HASH__;

export const isBrowser = typeof window !== 'undefined';
